export default __webpack_public_path__ + "static/media/img-slider-banpu-1.8a812d2b.png";